import React from 'react'

import {
  Layout,
  Header,
  SectionTitle,
  ItemTitle,
  Intro,
} from '../../../../components'

import { Link } from 'gatsby'

import CGM from '../../../../images/Grid_Example.png'
import Fixed from '../../../../images/FixedGridLarge.gif'
import Fluid from '../../../../images/FluidGridLarge.gif'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            A consistent grid system allows for a predictable and approachable
            experience across products that creates a familiar visual structure
            and centers the content the user came for.
          </p>
          <p>
            The system is comprised of columns, gutters and margins that define
            the grid as well as the breakpoints that definte its bounds. The
            Currency grid system is mobile-first and flexibly designed to
            accommodate various layout requirements while ensuring visual
            rhythm.
          </p>
        </Intro>
        <SectionTitle>Breakpoints</SectionTitle>
        <p>
          Breakpoints are bounded by min and max-width attributes. Screens in
          between the min and max width values will inherit all dimensions of
          the max-width. Depending on the type of grid you use, this will affect
          the size of your layout or the size of the surrounding margins.
        </p>
        <table class="table">
          <thead>
            <th>Breakpoint</th>
            <th>Device</th>
            <th>Breakpoint Range</th>
          </thead>
          <tbody>
            <tr>
              <td> xsmall </td>
              <td> Mobile </td>
              <td> 0-374px </td>
            </tr>
            <tr>
              <td> small </td>
              <td> Mobile </td>
              <td>375-575px </td>
            </tr>
            <tr>
              <td> medium </td>
              <td> Tablet </td>
              <td> 576-767px </td>
            </tr>
            <tr>
              <td> large </td>
              <td> Tablet </td>
              <td> 768-991px </td>
            </tr>
            <tr>
              <td> xlarge </td>
              <td> Desktop </td>
              <td> 992-1199px </td>
            </tr>
            <tr>
              <td> xxlarge</td>
              <td> Desktop </td>
              <td> 1200-1439px </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <SectionTitle>Customizing Columns, Gutters and Margins</SectionTitle>
        <p>
          Currency defines a standard set of breakpoints to bound the grid,
          however layout decisions such as the number and size of columns (up to
          twelve), size of gutters and margins, as well as the type of grid to
          employ, are up to a designer’s discretion.
        </p>
        <p>
          For ease of development handoff, best practice is to use a number of
          columns in factors of twelve. To give the content on your page a sense
          of framing, include page margins at least one size larger than the
          gutter.
        </p>
        <p>
          Use consistent vertical spacing in additon to your application of the
          grid to create a smooth and predictable visual flow. Refer to our{' '}
          <Link
            className="link"
            to={'/' + data.site + '/guidelines/spacing/design'}
          >
            Spacing Guidelines
          </Link>{' '}
          for Currency standard spacing values to apply to your designs.
        </p>
        <img
          src={CGM}
          width="100%"
          alt="Example of Columns, Gutters and Margins"
        />
        <hr />
        <SectionTitle className="l-margin-bottom--xlarge">
          Grid Types
        </SectionTitle>
        <ItemTitle>Fixed Grid</ItemTitle>
        <p>
          The fixed grid has a maximum width at each breakpoint range and
          responsive page margins. This grid prioritizes readability and is best
          used in content-specific pages with simple layouts.
        </p>
        <img
          src={Fixed}
          width="100%"
          alt="The behavior of content within a fixed grid"
        />
        <ItemTitle>Fluid Grid</ItemTitle>
        <p>
          The fluid grid has responsive columns in between each breakpoint and
          the layout can adapt to the available screen real estate. Fluid grids
          are ideal for more complex layouts, such as dashboards, where scaling
          the size of individual components is more useful than seeing more
          content on the page.
        </p>
        <img
          src={Fluid}
          width="100%"
          alt="The behavior of content within a fluid grid"
        />
      </Layout>
    </>
  )
}
